import React from 'react';
import useAuthStore from '../lib/auth-store';
import { Button } from './ui/button';
import { Eye, X } from 'lucide-react';

export default function ImpersonationBanner() {
  const { user, isImpersonating, stopImpersonation } = useAuthStore();

  if (!isImpersonating) return null;

  const name = user?.first_name
    ? `${user.first_name} ${user.last_name || ''}`.trim()
    : user?.full_name || user?.email || 'User';

  return (
    <div className="bg-amber-500 text-white px-4 py-2 flex items-center justify-between text-sm z-50" data-testid="impersonation-banner">
      <div className="flex items-center gap-2">
        <Eye className="h-4 w-4" />
        <span>
          You are viewing as <strong>{name}</strong> ({user?.role?.replace(/_/g, ' ')})
          {user?.tenant_name ? ` — ${user.tenant_name}` : ''}
        </span>
      </div>
      <Button
        size="sm"
        variant="outline"
        className="bg-white/20 border-white/40 text-white hover:bg-white/30 h-7"
        onClick={stopImpersonation}
        data-testid="exit-impersonation-btn"
      >
        <X className="h-3 w-3 mr-1" /> Exit Impersonation
      </Button>
    </div>
  );
}
